import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type ArrowClockwiseProps = {
    className?: string;
};

const ArrowClockwise: FunctionComponent<ArrowClockwiseProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'arrow-clockwise'}
            viewBox="0 0 250 250"
        >
            <polygon points="221.6,122.9 179.8,93.6 184.9,86.2 219.4,110.4 243.1,76.8 250.5,82 	" />
            <path
                d="M113.7,238.5c-61.7,0-112-50.2-112-112c0-61.7,50.2-112,112-112c56.1,0,103.9,41.9,111,97.5l-8.9,1.2
		c-6.6-51.1-50.5-89.7-102.1-89.7c-56.8,0-103,46.2-103,103s46.2,103,103,103C113.7,229.5,113.7,238.5,113.7,238.5z"
            />
        </svg>
    );
};
export default ArrowClockwise;
